import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import UdayImg from '../assets/images/Uday.png'

const Uday = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Uday - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={UdayImg}
                    Title="Uday"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971502756994"
                    PhoneNumber="+971 50 275 6994"
                    WhatsappLink="971502756994"
                    Whatsapp="+971 50 275 6994"
                    Email="uday@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={UdayImg}
                    Title="Uday"
                    Designation="Property Consultant"
                    PhoneNumberLink="+971502756994"
                    PhoneNumber="+971 50 275 6994"
                    WhatsappLink="971502756994"
                    Whatsapp="+971 50 275 6994"
                    Email="uday@800homes.ae"
                />
            </section>
        </>
    )
}

export default Uday
